import script from "./QxTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./QxTooltip.vue?vue&type=script&setup=true&lang=js"

import "./QxTooltip.vue?vue&type=style&index=0&id=38771660&lang=scss"

const __exports__ = script;

export default __exports__